'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var requestSuccess = function requestSuccess(config) {
  var artifactId = process.env.ARTIFACT_ID;
  var shouldAddArtifactId = config.url.includes('/_api/');

  if (artifactId && shouldAddArtifactId) {
    var _extends2;

    var headers = _extends({}, config.headers, (_extends2 = {}, _extends2[artifactIdHeader] = artifactId, _extends2));
    return _extends({}, config, { headers: headers });
  }
  return config;
};

exports.default = { requestSuccess: requestSuccess };
var artifactIdHeader = exports.artifactIdHeader = 'X-Wix-Client-Artifact-Id';